// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.
import type { ComplexCode } from '../types';

export const COMPLEX_META: Record<ComplexCode, { lat: number; lon: number; country: string; elevation: number; established: number; notes: string }> = {
  gdscc: {
    lat: 35.4267,
    lon: -116.89,
    country: 'United States',
    elevation: 1036,
    established: 1958,
    notes: 'Goldstone Deep Space Communications Complex in California\'s Mojave Desert. Host of the first operational DSN station.',
  },
  mdscc: {
    lat: 40.4314,
    lon: -4.2481,
    country: 'Spain',
    elevation: 835,
    established: 1964,
    notes: 'Madrid Deep Space Communications Complex near Robledo de Chavela. Operated by INTA on behalf of NASA.',
  },
  cdscc: {
    lat: -35.4014,
    lon: 148.9814,
    country: 'Australia',
    elevation: 680,
    established: 1965,
    notes: 'Canberra Deep Space Communication Complex near Tidbinbilla. Voyager 2\'s only southern-hemisphere link.',
  },
};
